export default __webpack_public_path__ + "static/exit_sign-013013c2eaec9f0f3415b01d5630af2b.jpg";